export interface ITripDetails {
  appointmentTime: string;
  bookingId: string;
  customerId: number;
  dropLatitude: number;
  dropLongitude: number;
  dropNotes: string;
  dropOffAddress1: string;
  dropOffAddress2: string;
  dropOffCity: string;
  dropOffState: string;
  dropOffZipCode: number;
  dropOffCounty: string;
  favoriteId: number;
  favoriteName: string;
  firstName: string;
  isWillCall: boolean;
  lastName: string;
  levelOfService: string;
  levelOfServiceCost: number;
  levelOfServiceId: number;
  modeId: number;
  paymentInstrumentId: number;
  personId: number;
  pickLatitude: number;
  pickLongitude: number;
  pickUpAddress1: string;
  pickUpAddress2: string;
  pickUpCity: string;
  pickUpState: string;
  pickUpZipCode: number;
  pickUpCounty: string;
  pickupNotes: string;
  providerCost: number;
  providerDistance: number;
  requestAssignmentId: number;
  requestPickTime: string;
  serviceUser: string;
  sourceSystemId: number;
  statusDetail: string;
  transportationCost: number;
  tripAttributes: "";
  tripCost: number;
  tripDate: string;
  tripId: string;
  tripReason: string;
  tripReasonId: number;
  tripStatusId: number;
  typeOfService: string;
  vehicleTypeCost: number;
  wandaSubscriptionPlan: string;
  wandaPlanPercentage: number;
  wandaPlusDiscountCost: number;
  id: number;
  promoCodeDetail: {
    promoCode: string;
    discountType: string;
    discountValue: string;
    discountedAmount: number;
  };
  redemptionId: string;
}

export interface ITripCardDetails {
  serviceUser: string;
  requestPickTime: string;
  appointmentTime: string;
  providerDistance: number;
  isWillCall: boolean;
  pickUpAddress1: string;
  dropOffAddress1: string;
  pickUpCity: string;
  pickUpState: string;
  dropOffCity: string;
  dropOffState: string;
  pickupNotes: string;
  dropNotes: string;
  dropOffZipCode: number;
  pickUpZipCode: number;
  bookingId: string;
  customerId: number;
  dropLatitude: number;
  dropLongitude: number;
  dropOffAddress2: string;
  dropOffCounty: string;
  favoriteId: number;
  favoriteName: string;
  firstName: string;
  lastName: string;
  levelOfService: string;
  levelOfServiceCost: number;
  levelOfServiceId: number;
  modeId: number;
  paymentInstrumentId: number;
  personId: number;
  pickLatitude: number;
  pickLongitude: number;
  pickUpAddress2: string;
  pickUpCounty: string;
  providerCost: number;
  requestAssignmentId: number;
  sourceSystemId: number;
  statusDetail: string;
  transportationCost: number;
  tripAttributes: "";
  tripCost: number;
  tripDate: string;
  tripId: string;
  tripReason: string;
  tripReasonId: number;
  tripStatusId: number;
  typeOfService: string;
  vehicleTypeCost: number;
  wandaSubscriptionPlan: string;
  wandaPlanPercentage: number;
  wandaPlusDiscountCost: number;
  id: number;
}
export interface IFavRecords {
  selectedLeg: ITripDetails[];
  allLegs: ITripDetails[];
  legsCount: number;
}
export interface IFavoritesRequest {
  personId: number;
  name: string;
  bookingId: number[];
  requestAssignmentId: number;
  favoriteId: number;
}

export interface IUpsertPersonOrgRelData {
  personOrganizationRelId: number;
  organizationId: number;
  personId: number;
  personTypeId: number;
  relationshipRefId: number;
  isActive: boolean;
}

export interface ccpExtraDetailsInfo {
  email: string;
  id?: number;
  insertParameter: number;
  personId?: number;
  registerFor?: string;
  CCPIntake?: boolean;
  registrationComplete?: boolean;
  ViewBenefit?: boolean;
  MatchBenefit?: boolean;
}

export interface ITripDetailsInfo {
  wandaCustomerCareNumber: string;
  wandaPlusDiscount: string;
  wandaSubscriptionCost: string;
}

export function defaultTripDetailsInfo() {
  return {
    wandaCustomerCareNumber: "",
    wandaPlusDiscount: "",
    wandaSubscriptionCost: "",
  };
}

export enum TripDetailsInfo {
  WandaCustomerCareNumber = "WandaCustomerCareNumber",
  WandaPlusDiscount = "WandaPlusDiscount",
  WandaPrivatePay = "WandaPrivatePay",
}
